import Dropdown from "react-dropdown-select";

import React from "react";
import { enumAvailableLanguages } from "./models/SettingsEnums";
import { useOnChangeWatcher } from "./models/useOnChangeWatcher";

const locales: any = {
  en: { title: "English" }, // no itx
  de: { title: "Deutsch" }, // no itx
  /* Add more language options as needed */
};

function LanguagePicker(props: { style?: any; className?: any }) {
  const { style, className } = props;

  useOnChangeWatcher(state.settings);
  const selectedLanguage = [
    {
      value: state.settings.uiLanguage,
      label: getLabelForLanguage(state.settings.uiLanguage),
    },
  ];
  const availiableLanguages = state.availiableLanguages;

  async function handleLanguageChange(language: enumAvailableLanguages | undefined) {
    if (language) {
      await state.settings.setUiLanguage(language);
    }
  }
  let options = new Array<any>();

  availiableLanguages.forEach((language) => {
    options.push({
      value: language,
      label: getLabelForLanguage(language),
    });
  });

  function getLabelForLanguage(language: any) {
    switch (language) {
      case enumAvailableLanguages.german:
        return "Deutsch"; // no itx
      case enumAvailableLanguages.italian:
        return "Italiano"; // no itx
      case enumAvailableLanguages.spanish:
        return "Espanol"; // no itx
      case enumAvailableLanguages.french:
        return "Francais"; // no itx
      case enumAvailableLanguages.swedish:
        return "Svenska"; // no itx
      case enumAvailableLanguages.english:
      default:
        return "English"; // no itx // No need to translate language labels
    }
  }

  return (
    <div>
      <Dropdown
        className={`select ${className}`}
        options={options}
        values={selectedLanguage}
        onChange={(values) => {
          handleLanguageChange(values[0].value);
        }}
        color="#666" // "var(--dropdown-color)"
        style={style}
        searchable={false}
        clearable={false}
      />
    </div>
  );
}

export default LanguagePicker;
